import { useEffect, useState } from "react";
import { apiUrl } from "./config";

export const useGlobalSearch = (searchQuery) => {
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Don't search if query is too short
    if (!searchQuery || searchQuery.length < 2) {
      setSearchResults([]);
      setLoading(false);
      return;
    }

    const abortController = new AbortController();

    const fetchSearchResults = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("accessToken");
        const url = new URL(`${apiUrl}/search/`);
        url.searchParams.append("q", searchQuery);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          signal: abortController.signal,
        });

        const data = await response.json();

        if (response.ok) {
          setSearchResults(data.results || []);
        } else {
          throw new Error(data.error || "Search failed");
        }
      } catch (err) {
        // Don't set error if request was aborted
        if (err.name !== "AbortError") {
          console.error("Global search error:", err);
          setError(err);
          setSearchResults([]);
        }
      } finally {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      }
    };

    // Debounce search to avoid too many requests
    const timeoutId = setTimeout(() => {
      fetchSearchResults();
    }, 300);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      abortController.abort();
    };
  }, [searchQuery]);

  return {
    searchResults,
    loading,
    error,
  };
};
